import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

type BadgeVariant = 'primary' | 'success' | 'danger' | 'warning' | 'info' | 'secondary' | 'light' | 'dark';

@Component({
    selector: 'app-badge',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './badge.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
    text = input.required<string>();
    variant = input<BadgeVariant>('primary');
    pill = input<boolean>(true);
}
